import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const CUSTOMER_BULK_DELETE_PREVIEW_API_PATH = "/v1/customer/bulk-delete/preview" as const;

export type CustomerBulkDeletePreviewBody =
  paths[typeof CUSTOMER_BULK_DELETE_PREVIEW_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type CustomerBulkDeletePreviewResponse =
  paths[typeof CUSTOMER_BULK_DELETE_PREVIEW_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export function useCustomerBulkDeletePreviewQuery({
  body,
  enabled,
}: {
  body: CustomerBulkDeletePreviewBody;
  enabled: boolean;
}) {
  return useQuery({
    queryKey: ["customer", "bulk-delete", "preview", body],
    queryFn: async (): Promise<CustomerBulkDeletePreviewResponse> => {
      const response = await alphartisApiAxios.post<CustomerBulkDeletePreviewResponse>(
        CUSTOMER_BULK_DELETE_PREVIEW_API_PATH,
        body,
      );
      return response.data;
    },
    enabled,
  });
}
